import { uploadMultipleFiles } from "../../actions/chatActions";
import { toast } from "react-toastify";

function resolveUploadError(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) {
    return detail;
  }
  if (Array.isArray(detail) && detail.length) {
    return String(detail[0]);
  }
  return "Не вдалося надіслати вкладення.";
}

export const useChatUpload = (chatId) => {
  const upload = async (files = [], images = [], { onComplete } = {}) => {
    if (!files.length && !images.length) return;
    try {
      await uploadMultipleFiles(chatId, images, files);
      onComplete?.();
    } catch (error) {
      toast.error(resolveUploadError(error));
      onComplete?.();
      throw error;
    }
  };

  return { upload };
};
